module.exports = __webpack_public_path__ + "static/media/31import-63.c57ee9dc.xlsx";